import { BrowserModule } from '@angular/platform-browser'
import { NgModule, ErrorHandler, provideZoneChangeDetection } from '@angular/core'
import { ReactiveFormsModule } from '@angular/forms'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import * as Sentry from '@sentry/angular'

import { AppRoutingModule } from './app-routing.module'
import { AppComponent } from './app.component'
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http'
import { Router, RouterModule } from '@angular/router'
import { SideNavComponent } from './core/side-nav/side-nav.component'
import { RestrictedProductService } from './core/restricted-product/services/restricted-product.service'
import { UserPermissionsService } from './core/user-permissions/user-permissions.service'
import { MainComponent } from './main/main.component'
import { SharedModule } from './shared/shared.module'
import { UserService } from './shared/services/user.service'
import { environment } from '../environments/environment'
import { DialogService } from './shared/services/dialog.service'
import { HttpClientInterceptor } from './shared/interceptors/http.client.interceptor'
import { AppInsightsConfig, AppInsightsErrorHandler, AppInsightsModule } from '@overtur/app-insights'
import { MaterialModule } from './material.module'
import { PhxAngularMaterialModule } from '@overtur-monorepo/phx-angular-material'
import { KeyingSharedModule } from '@overtur-monorepo/keying-shared'
import { TourGuideComponent } from './shared/components/tour-guide/tour-guide.component'
import { SupportButtonComponent } from './shared/components/support-button/support-button.component'
import { TourAnchorMatMenuDirective, TourStepTemplateComponent } from 'ngx-ui-tour-md-menu'

const appInsightsConfig: AppInsightsConfig = {
  appInsightsInstrumentationKey: environment.appInsightsInstrumentationKey,
  appInsightsCorrelationDomains: environment.appInsightsCorrelationDomains,
}

@NgModule({
  declarations: [AppComponent, SideNavComponent, MainComponent],
  bootstrap: [AppComponent],
  imports: [
    AppInsightsModule,
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    SharedModule.forRoot(),
    RouterModule,
    ReactiveFormsModule,
    MaterialModule,
    PhxAngularMaterialModule,
    KeyingSharedModule,
    TourGuideComponent,
    SupportButtonComponent,
    TourAnchorMatMenuDirective,
    TourStepTemplateComponent,
  ],
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    UserService,
    { provide: HTTP_INTERCEPTORS, useClass: HttpClientInterceptor, multi: true },
    { provide: 'userService', useClass: UserService, multi: false },
    { provide: 'environment', useValue: environment, multi: false },
    { provide: 'appInsightsEnv', useValue: appInsightsConfig },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    // Sentry error handler only (AppInsights still tracks other telemetry)
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: false,
      }),
    },
    RestrictedProductService,
    UserPermissionsService,
    DialogService,
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AppModule {}
